import React from 'react'

function Leaderboards() {
  return (
    <div>Leaderboards</div>
  )
}

export default Leaderboards